import { Component } from '@angular/core';

@Component({
  selector: 'app-salesman-sales-summary',
  standalone: false,
  
  templateUrl: './salesman-sales-summary.component.html',
  styles: ``
})
export class SalesmanSalesSummaryComponent {

}
